import { Reveal, OceanTag } from "./kit";
import { WHY_OCEAN_CARDS, OCEAN_WORKFLOW } from "../../data/oceanContent";
import { ArrowRight } from "lucide-react";

export default function WhyOcean() {
  return (
    <section id="why-ocean" data-testid="ocean-why-section" className="relative py-24 lg:py-32">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal>
          <OceanTag index="01" label="Why the Ocean?" />
          <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-oseaglass leading-[0.95] max-w-4xl">
            Some of India's most important environments lie <span className="text-oreef">beneath the surface.</span>
          </h2>
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-oseaglass/70 leading-relaxed">
            Satellites see the ocean from above; divers document it up close. The two are complementary — but they do
            not measure the same things. This expedition explores how authorised underwater observations could be
            integrated with satellite imagery and geospatial analytics.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {WHY_OCEAN_CARDS.map((c, i) => (
            <Reveal key={c.title} delay={0.06 * i}>
              <article className="group relative h-full border border-oreef/15 bg-oabyss/40 overflow-hidden hover:border-oreef/40 transition-colors duration-300" data-testid={`why-card-${i}`}>
                <div className="h-44 overflow-hidden">
                  <img src={c.img} alt={c.title} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700" />
                </div>
                <div className="p-6">
                  <span className="font-mono text-[10px] tracking-[0.3em] text-ocoral">0{i + 1}</span>
                  <h3 className="font-display font-semibold text-xl text-oseaglass mt-2 leading-tight tracking-wide">{c.title}</h3>
                  <p className="mt-3 text-sm text-oseaglass/65 leading-relaxed">{c.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-16 border border-oreef/15 bg-oabyss/30 p-7 sm:p-10" data-testid="ocean-workflow">
            <div className="font-mono text-[10px] tracking-[0.3em] text-oreef mb-7">PROPOSED OBSERVATION WORKFLOW</div>
            <div className="flex flex-col md:flex-row md:items-stretch gap-3 md:gap-0">
              {OCEAN_WORKFLOW.map((step, i) => (
                <div key={step} className="flex items-center gap-3 md:flex-1">
                  <div className="flex-1 border border-oslate/25 bg-onavy/60 px-4 py-4 h-full flex flex-col justify-center">
                    <span className="font-mono text-[9px] text-oslate tracking-[0.25em]">STEP {i + 1}</span>
                    <span className="font-display font-semibold text-oseaglass text-sm sm:text-base leading-tight mt-1">{step}</span>
                  </div>
                  {i < OCEAN_WORKFLOW.length - 1 && <ArrowRight size={16} className="text-ocoral shrink-0 rotate-90 md:rotate-0 mx-auto md:mx-1" />}
                </div>
              ))}
            </div>
            <p className="mt-6 text-xs font-mono text-oslate leading-relaxed tracking-wide">
              A proposed workflow only. Field observations require appropriate sampling methods, documentation and expert
              interpretation before they can support scientific conclusions.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
